import { render } from "./RoleUserTag.vue?vue&type=template&id=8882e16c"
import script from "./RoleUserTag.vue?vue&type=script&lang=js"
export * from "./RoleUserTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__